

















export default {
  name: "BaseIconAlert",
  props: {
    icon: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "lg"
    }
  }
};
